import React, {useEffect, useState} from "react";

import {Button, Popconfirm, Tag, Tooltip} from "antd";

import {TasksViewer} from "./TasksViewer";
import api from "../../api";
import {checkAllPermissions} from "../../helpers";

export const getStatusTag = status => {
	const labels = {
		pending: <Tag color={"default"}>Pending</Tag>,
		rejected: <Tag color={"red"}>Rejected</Tag>,
		completed: <Tag color={"green"}>Completed</Tag>,
		approved: <Tag color={"green"}>Approved</Tag>,
		in_progress: <Tag color={"yellow"}>In Progress</Tag>,
	};

	return labels[status] || <Tag>{status}</Tag>;
};

export function BucketApproveViewer(props) {
	const [tasks, setTasks] = React.useState([]);
	const [user, setUser] = useState({});
	const [isAdmin, setIsAdmin] = useState(false);
	const [userTasks, setUserTasks] = useState([]);

	useEffect(() => {
		getUser();
		checkIfAdmin();
	}, []);

	useEffect(() => {
		getUserTasks();
	}, [user]);

	const checkIfAdmin = () => {
		checkAllPermissions(["admin"])
			.then(() => setIsAdmin(true))
			.catch(() => setIsAdmin(false));
	};

	const getUser = () => {
		api.get("/get_current_user").then(json => setUser(json.data));
	};

	const getUserTasks = () => {
		api.get(
			`/projects/${props.projectId}/tasks/object_id/${props.bucket._id}/object_type/bucket/user/${user["email"]}`,
		).then(json => {
			setUserTasks(json.data);
		});
	};

	const getTasks = () => {
		api.get(`/projects/${props.projectId}/tasks/object_id/${props.bucket._id}/object_type/bucket`).then(json => {
			setTasks(json.data);
		});
	};

	const getCurrentTask = () => tasks.filter(x => x["status"] === "active");

	useEffect(() => {
		getTasks();
		getUserTasks();
	}, [props]);

	const handleApprove = () => {
		getTasks();
		getUserTasks();
		props.refresh();
	};

	return (
		<div>
			<div>Workflow status: {getStatusTag(props.bucket.status)} </div>
			{props.bucket.status !== "in_progress" && props.bucket.status !== "approved" && (
				<div style={{marginTop: 10}}>
					<Popconfirm
						title="Are you sure you want to approve this bucket?"
						onConfirm={() => props.onApprovalStart(props.bucket._id)}
						okText="Yes, Start approve"
						cancelText="No">
						<Button style={{margin: "0 5px"}} primary>
							<Tooltip title={`Approve Bucket ${props.bucket.name} ?`}>
								<div>Start approve process</div>
							</Tooltip>
						</Button>
					</Popconfirm>
				</div>
			)}
			{props.bucket.status !== "pending" && (
				<div style={{marginTop: 10}}>
					<TasksViewer
						current={getCurrentTask()}
						onApprove={handleApprove}
						userInfo={user}
						isAdmin={isAdmin}
						objectType={"bucket"}
						projectId={props.projectId}
						itemInfo={props.bucket}
						userTasks={userTasks}
					/>
				</div>
			)}
		</div>
	);
}
